import React from "react";
import { DialogButton } from "../../components";
import { Stack, Typography } from "@mui/material";

const WorkOrderTestingBar = () => {
  return (
    <Stack
      direction="row"
      gap="10px"
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography variant="caption">Work Order Testing</Typography>
      <DialogButton
        name="add-work-order-test"
        label="Add Testing"
        variant="contained"
        size="xsmall"
      />
    </Stack>
  );
};

export default WorkOrderTestingBar;
